function openCloseDynamicAccordionBlade(event) { 

    var elementParent = event.target.parentNode;
    var isOpen = elementParent.classList.contains('accordion__item--open');

    if (isOpen) {
        elementParent.classList.remove('accordion__item--open');
        elementParent.setAttribute('aria-expanded', 'false');
    } else {
        elementParent.classList.add('accordion__item--open');
        elementParent.setAttribute('aria-expanded', 'true');
    }
}

function calculateHeight() {
    document.querySelectorAll('.accordion__item').forEach(function (e) {
        var body = e.querySelector('.accordion__content');
        var height = e.offsetHeight + body.scrollHeight;

        e.style.maxHeight = height + 40 + "px";
    });
}

function applyClicks() {
    document.querySelectorAll('.accordion__title').forEach(function (r, index) {
        r.addEventListener('click', function (event) {

            event.preventDefault();
            openCloseDynamicAccordionBlade(event)

        }, false);
    });
}

applyClicks();


function initAccordions() {
    $('.accordion').each(function () {
        // apply height of each accordion on load
        accordion_height = $(this).find('.accordion__content')[0].scrollHeight + $(this).find('.accordion__title').outerHeight();
        $(this).css('max-height', accordion_height);
    })

    $('.accordion__title').click(function () {
        var accordion_parent = $(this).parent();

        // Close nested accordions and open
        //$(this).parent().find('.accordion').removeClass('accordion--open');
        accordion_parent.toggleClass('accordion--open');

        // Update aria tags
        if (accordion_parent.attr('aria-expanded') === 'true') {
            accordion_parent.attr('aria-expanded', 'false');
        } else {
            accordion_parent.attr('aria-expanded', 'true');
        }

    });
}